import React from 'react'

import { number, oneOfType, string } from 'prop-types'

import DesktopOnlyTooltip from 'Pods/Shared/DesktopOnlyTooltip/DesktopOnlyTooltip'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function VariationsBadge({ sessionId, count }) {
  const t = useTranslation()
  const label = t('sidebar.modelCard.variationsCount', { count })

  return (
    <span className="model-card__variations">
      <DesktopOnlyTooltip
        id={`variations-count-${sessionId}`}
        content={label}
        place="top"
        className="model-card__variations-trigger"
      >
        <span className="model-card__variations-badge cgt-caption-semibold" role="img" aria-label={label}>
          {count}
        </span>
      </DesktopOnlyTooltip>
    </span>
  )
}

VariationsBadge.propTypes = {
  sessionId: oneOfType([string, number]).isRequired,
  count: number.isRequired,
}

export default VariationsBadge
